"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MeetingEnded = require("./MeetingEnded");
Object.keys(_MeetingEnded).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MeetingEnded[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MeetingEnded[key];
    }
  });
});